import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useState, useEffect } from "react";
import Pagination from "./Pagination";
import Filters from "./Filters";
import Table from "./Table";

const Layout = ({
  dataArray,
  columns,
  pagination = false,
  allowFilters = true,
  filters,
  props,
}) => {
  const [data, setData] = useState(dataArray);
  const [rowSelection, setRowSelection] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");

  useEffect(() => {
    setData(dataArray);
  }, [dataArray]);

  // Check if using server-side pagination (filters.pagination provided)
  // or client-side pagination (pagination=true but no filters.pagination)
  const useClientPagination = pagination && !filters?.pagination;

  const table = useReactTable({
    data,
    columns,
    state: {
      rowSelection,
      globalFilter,
    },
    onColumnFiltersChange: setGlobalFilter,
    onGlobalFilterChange: setGlobalFilter,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    ...(useClientPagination && {
      getPaginationRowModel: getPaginationRowModel(),
    }),
  });

  return (
    <div>
      <div style={{ padding: 0, margin: 0 }} hidden={!allowFilters}>
        <Filters
          filters={filters}
          globalFilter={globalFilter}
          onChangeGlobalFilterAction={(value) => setGlobalFilter(String(value))}
          props={props}
        />
      </div>
      <div>
        <Table key={data} table={table} flexRender={flexRender} {...props} />
        {/* Server-side pagination */}
        {pagination && filters?.pagination && (
          <Pagination
            pagination={pagination}
            tablePageSize={filters.pagination.perPage}
            tableSetPageSize={(e) => {
              if (filters.pagination.setPerPage) {
                filters.pagination.setPerPage(Number(e.target.value));
              }
            }}
            tableSetFirstPageIndex={() => {
              filters.pagination.action(filters.pagination.currentPage, 1);
            }}
            tableSetLastPageIndex={() => {
              filters.pagination.action(
                filters.pagination.currentPage,
                filters.pagination.lastPage
              );
            }}
            tableSetNextPage={() => {
              if (
                filters.pagination.currentPage < filters.pagination.lastPage
              ) {
                filters.pagination.action(
                  filters.pagination.currentPage,
                  filters.pagination.currentPage + 1
                );
              }
            }}
            tableSetPreviousPage={() => {
              if (filters.pagination.currentPage > 1) {
                filters.pagination.action(
                  filters.pagination.currentPage,
                  filters.pagination.currentPage - 1
                );
              }
            }}
            previousPageAllowed={filters.pagination.currentPage <= 1}
            nextPageAllowed={
              filters.pagination.currentPage >= filters.pagination.lastPage
            }
            customPageSizeAllowed={true}
            paginationTextValue={`${filters.pagination.currentPage} od ${filters.pagination.lastPage}`}
          />
        )}
        {/* Client-side pagination */}
        {useClientPagination && (
          <Pagination
            pagination={pagination}
            tablePageSize={table.getState().pagination.pageSize}
            tableSetPageSize={(e) => {
              table.setPageSize(Number(e.target.value));
            }}
            tableSetFirstPageIndex={() => table.setPageIndex(0)}
            tableSetLastPageIndex={() =>
              table.setPageIndex(table.getPageCount() - 1)
            }
            tableSetNextPage={() => table.nextPage()}
            tableSetPreviousPage={() => table.previousPage()}
            previousPageAllowed={!table.getCanPreviousPage()}
            nextPageAllowed={!table.getCanNextPage()}
            customPageSizeAllowed={true}
            paginationTextValue={`${
              table.getState().pagination.pageIndex + 1
            } od ${table.getPageCount()}`}
          />
        )}
      </div>
    </div>
  );
};

export default Layout;
